import React from 'react'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {RenderField} from '../../../components/forms/HookFormFields'
import {PasswordChange} from '../../../api'
import * as ReactBootstrap from 'react-bootstrap'

interface PasswordChangeFormProps {
    onSubmit: (values: PasswordChange) => void
}

interface PasswordChangeFormData {
    old_password: string
    new_password1: string
    new_password2: string
}

const passwordChangeSchema = yup.object().shape({
    old_password: yup
        .string()
        .test('required', 'Required', (value: string | undefined) => !!value?.trim()),
    new_password1: yup
        .string()
        .test('required', 'Required', (value: string | undefined) => !!value?.trim()),
    new_password2: yup
        .string()
        .test('required', 'Required', (value: string | undefined) => !!value?.trim())
        .test(
            'match',
            'Passwords do not match',
            function (value: string | undefined) {
                return value === this.parent.new_password1
            }
        ),
})

export const PasswordChangeForm: React.FC<PasswordChangeFormProps> = ({
                                                                          onSubmit,
                                                                      }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: {errors, isSubmitting, isDirty},
    } = useForm<PasswordChangeFormData>({
        resolver: yupResolver(passwordChangeSchema),
        defaultValues: {
            old_password: '',
            new_password1: '',
            new_password2: '',
        },
    })

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <RenderField
                label="Current Password"
                type="password"
                error={errors.old_password?.message}
                registerProps={register('old_password')}
            />
            <RenderField
                label="Password"
                type="password"
                error={errors.new_password1?.message}
                registerProps={register('new_password1')}
            />
            <RenderField
                label="Confirm Password"
                type="password"
                error={errors.new_password2?.message}
                registerProps={register('new_password2')}
            />
            <div style={{display: 'flow-root'}}>
                <br/>

                <ReactBootstrap.Button
                    className={'float-end btn btn-dark'}
                    variant="dark"
                    type="submit"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Hold' : 'Submit'}
                </ReactBootstrap.Button> <ReactBootstrap.Button
                style={{padding: '8px 10px', marginRight: "10px"}}
                type="button"
                className="float-end  text-dark btn-sm btn-link"
                disabled={!isDirty || isSubmitting}
                onClick={() => reset()}
            >
                Clear
            </ReactBootstrap.Button>
            </div>
        </form>
    )
}
